const checkForm = event => {
  event = event ? event : window.event;
  const form = event.target ? event.target : event.srcElement;

  if (form.checkValidity() === false) {
    event.preventDefault();
    event.stopPropagation();
  }

  [].forEach.call(form.elements, el => checkValidity(el));

  form.classList.add("was-validated");
};
const shouldValidate = el =>
    (el.hasAttribute("data-validate") && 
    !(el.hasAttribute("readonly") || el.readonly) &&
    !(el.hasAttribute("disabled") || el.disabled) 
  );

const checkValidity = el => {
  if (shouldValidate(el)) {

    const validations = ["patternMismatch","valueMissing" ];

    for (var key of validations) {
      if (el.validity[key]) {
        const data_id = "data-" + key.replace(/[A-Z]/g, "-$&").toLowerCase();
        if (el.hasAttribute(data_id)) {
          el.nextElementSibling.innerHTML = el.getAttribute(data_id);
          el.setAttribute("aria-invalid", "true");
          return;
        }
      }
    }
    field.removeAttribute("aria-invalid");  
    el.nextElementSibling.innerHTML = "";
  }
};

const wireSubmit = form => {
  form.addEventListener("submit", checkForm, false);
};

const validateForms = () => {
  const forms = document.getElementsByClassName("needs-validation");
  [].forEach.call(forms, wireSubmit);
};

window.addEventListener("load", validateForms, false);



// WEBPACK FOOTER //
// ./Assets/js/validation.js